import { ProfileAvatar } from '@care/react-component-lib';
import { Stack, Typography } from '@mui/material';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_jobSearchResults_seoSegmentationJob as SEOJob } from '@/__generated__/seoSegmentationListingPage';
import { formatStartDate } from '@/utils/formatStartDate';

export interface JobSeekerAvatarProps {
  job: SEOJob;
  isClientSearchResultsQuery: boolean;
}

export const JobSeekerAvatar = ({ job, isClientSearchResultsQuery }: JobSeekerAvatarProps) => {
  const {
    job: { startDate },
  } = job;

  const profileAvatarProps = {
    alt: `Seeker profile avatar for ${job.job.title}`,
    size: 'squareSmall',
    src: job.seekerAvatar ?? undefined,
    slotProps: {
      avatar: {
        imgProps: isClientSearchResultsQuery
          ? { loading: 'eager' as const }
          : { loading: 'lazy' as const },
      },
    },
  } as const;
  const formattedStartDate = formatStartDate(startDate);

  return (
    <ProfileAvatar {...profileAvatarProps}>
      <Stack spacing={0.5}>
        <Typography variant="h5" component="div" textAlign="center">
          {formattedStartDate.month.toLocaleUpperCase()}
        </Typography>
        <Typography variant="h1" component="div" textAlign="center">
          {formattedStartDate.day.toUpperCase()}
        </Typography>
      </Stack>
    </ProfileAvatar>
  );
};
